"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copySchema = exports.replaceTimestamps = void 0;
const superstruct_1 = require("superstruct");
const utils_1 = require("../utils");
function replaceTimestamps(schema) {
    return Object.entries(schema).reduce((acc, [key, propertyStruct]) => {
        if (propertyStruct.type === utils_1.TimestampStruct.type) {
            return {
                ...acc,
                [key]: (0, superstruct_1.optional)((0, superstruct_1.coerce)((0, superstruct_1.string)(), (0, superstruct_1.object)(), (value) => {
                    if (utils_1.TimestampStruct.is(value)) {
                        return value.toDate().toISOString();
                    }
                    else {
                        // Field value is usually used for server timestamps
                        return new Date().toISOString();
                    }
                })),
            };
        }
        else if (propertyStruct.type == 'object' || propertyStruct.type == 'type') {
            return {
                ...acc,
                [key]: copySchema(propertyStruct),
            };
        }
        else {
            return { ...acc, [key]: propertyStruct };
        }
    }, {});
}
exports.replaceTimestamps = replaceTimestamps;
function copySchema(struct) {
    return new superstruct_1.Struct({
        ...struct,
        schema: replaceTimestamps(struct.schema),
    });
}
exports.copySchema = copySchema;
//# sourceMappingURL=replaceTimestamps.js.map